module.exports = __webpack_public_path__ + "3faa3ee73de7aecddb98b09a991c57ea.png";